import * as mainStyles from "../../../styles/layout/main.module.scss";
import FilAriane from "../../page_structure/FilAriane";
import React from "react";

const EventLayout = ({children, ...props}) => {

    let displayLang = ''
    if (props && props.lang) {
        displayLang = props.lang.toLowerCase()
    }

    return (
        <div className={mainStyles.centerMaxSize}>
            <div className={mainStyles.innerTemplate} id="main-content-page">
                <div className={mainStyles.eventTemplateFilAriane}>
                    <FilAriane ariane={props.filAriane} url={props.url} lang={displayLang}></FilAriane>
                </div>
                {children}
            </div>
        </div>
    );
};

export default EventLayout;
